function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 13.499,
  r: 1
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.5a1 1 0 0 0 1-1 1 1 0 1 1 1.4.918 2.333 2.333 0 0 0-1.4 2.139V11a1 1 0 1 0 2 0v-.443a.336.336 0 0 1 .2-.307A3 3 0 1 0 9.5 7.5a1 1 0 0 0 1 1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 1H2a2 2 0 0 0-2 2v13.552A1.953 1.953 0 0 0 2 18.5h2.5V22a1 1 0 0 0 1.569.823l6.243-4.323H22a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm0 15.25a.25.25 0 0 1-.25.25H12a1 1 0 0 0-.569.178L6.5 20.091V17.5a1 1 0 0 0-1-1H2.25a.25.25 0 0 1-.25-.25v-13A.25.25 0 0 1 2.25 3h19.5a.25.25 0 0 1 .25.25z"
});

var SvgMessagesBubbleSquareQuestionAlternateBold = function SvgMessagesBubbleSquareQuestionAlternateBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default SvgMessagesBubbleSquareQuestionAlternateBold;